/* eslint-disable jira/filename-case */
import { ISSUE_SEARCH_DEFAULT_COLUMNS } from '@jira/global-pages__dashboard-common/src/constants.tsx';
import { VERTICAL_BAR_DECODED, VERTICAL_BAR_ENCODED } from '../constants.tsx';

export const convertUserPrefsToColumnNames = (columns: string | number | boolean): string[] =>
	typeof columns === 'string' && columns !== '' && columns !== '--Default--'
		? columns
				.split(VERTICAL_BAR_DECODED)
				.map((col) => col.replaceAll(VERTICAL_BAR_ENCODED, VERTICAL_BAR_DECODED))
		: ISSUE_SEARCH_DEFAULT_COLUMNS;
